<svg viewBox="0 0 16 18" xmlns="http://www.w3.org/2000/svg">
<path fill="currentColor" d="M15.707 8.75703L6.94903 3.0622e-05L6.24303 0.707031L13.794 8.25803L3.15697e-05 8.25803L3.15816e-05 9.25703L13.794 9.25703L6.05103 17L6.75703 17.707L15.707 8.75703Z" />
</svg>
